import { Outlet, createRootRoute, type ErrorComponentProps } from "@tanstack/react-router";
import { ToastProvider } from "@/shared/notifications";
import { useT } from "@/shared/i18n";

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RootErrorComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <ToastProvider />
    </>
  );
}

function RootErrorComponent({ error, reset }: ErrorComponentProps) {
  const t = useT();
  const message = error instanceof Error ? error.message : t("errors.generic");

  return (
    <main className="min-h-screen bg-bg px-6 py-10 text-ink">
      <div className="mx-auto flex min-h-[70vh] max-w-xl flex-col justify-center gap-5">
        <p className="text-label text-accent">{t("errors.routeEyebrow")}</p>
        <h1 className="font-display text-[52px] leading-[0.9] uppercase">
          {t("errors.routeTitle")}
        </h1>
        <p className="text-sm leading-6 text-muted">{message}</p>
        <button
          type="button"
          onClick={reset}
          className="inline-flex min-h-10 w-fit items-center rounded-sm border border-border bg-surface px-4 text-xs font-semibold text-ink transition-colors hover:border-accent hover:text-accent"
        >
          {t("errors.tryAgain")}
        </button>
      </div>
    </main>
  );
}
